exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid[data-v-0efc64c6] {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n.col-span-full[data-v-0efc64c6] {\n  grid-column: 1 / -1;\n}\n.col-span-3[data-v-0efc64c6] {\n  grid-column: span 3 / span 3;\n}\n.col-span-2[data-v-0efc64c6] {\n  grid-column: span 2 / span 2;\n}\n", ""]);

// exports
